import { z } from "zod";

export const iconSchema = z.string(); // TODO Importing icon map is dangerous
